import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import i18n from 'i18n';
import {getMaxImageSize} from '../../../../config/app';
import API from '../lib/api';
import UploadAvatar from './upload-avatar';
import {displayAlert} from '../actions/app';

const MAX_IMAGE_SIZE = getMaxImageSize();

const UploadAvatarContainer = createClass({

  propTypes: {
    image: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['ProfileImage', 'CampaignCover', 'Ad'])
  },

  getDefaultProps() {
    return {
      type: 'ProfileImage'
    };
  },

  getInitialState() {
    return {
      loading: false
    };
  },

  onSelectImage(event) {
    const uploadData = {};

    this.setState({
      loading: true
    });

    if (!event.target.files[0]) return;

    uploadData.file = event.target.files[0];
    if (uploadData.file.size > MAX_IMAGE_SIZE) return this.onMaxFileSizeExceeded();
    uploadData.type = this.props.type;

    API.uploadImage(uploadData, (err, res) => {
      if (err || res.code) return console.error(err);
      this.setState({
        loading: false
      });

      if (this.props.onChange) this.props.onChange(res.id, res.data.url);
    });
  },

  onMaxFileSizeExceeded() {
    this.setState({loading: false}, () => {
      this.clearUploadInputVal();

      displayAlert({
        type: 'warning',
        title: i18n.get('INF_SETTINGS_ACCOUNT_UPLOAD_MAX_FILE_SIZE_WARNING_TITLE'),
        message: i18n.get('INF_SETTINGS_ACCOUNT_UPLOAD_MAX_FILE_SIZE_WARNING_MESSAGE')
      });
    });
  },

  clearUploadInputVal() {
    this.uploader.input.value = null;
  },

  render() {
    const {loading} = this.state;
    const {image, value, label} = this.props;

    return (
      <UploadAvatar
        image={image || value}
        label={label}
        loading={loading}
        onChange={this.onSelectImage}
        ref={ref => this.uploader = ref}
      />
    );
  }

});

module.exports = UploadAvatarContainer;
